import { Text } from "~/components/Text";
import { SectionHeading } from "~/components/SectionHeading";

type TicketInclusion = {
  id: string;
  text: string;
  position: number;
};

type TicketInclusionsProps = {
  inclusions: TicketInclusion[];
};

export function TicketInclusions({ inclusions }: TicketInclusionsProps) {
  if (inclusions.length === 0) return null;

  const sorted = [...inclusions].sort((a, b) => a.position - b.position);

  return (
    <div className="mt-2">
      <SectionHeading>Your ticket includes</SectionHeading>
      <ul className="mt-4 flex flex-col gap-2">
        {sorted.map((inclusion) => (
          <li
            key={inclusion.id}
            className="flex items-center gap-3 rounded-lg border border-butter-cream bg-white/80 px-5 py-3"
          >
            <span
              aria-hidden
              className="inline-block h-2 w-2 flex-shrink-0 rounded-full bg-butter-pink"
            />
            <Text as="span" variant="secondary" size="md">
              {inclusion.text}
            </Text>
          </li>
        ))}
      </ul>
    </div>
  );
}
